import React from "react";
import { Paper, RaisedButton } from "material-ui";
import moment from "moment";

import { capitalize } from "../../../util";

import BasicHtmlField from "../basic-html-field.jsx";

import NoteActions from "../../../actions/NoteActions";

const STYLES = {
  note: {
    padding: "1em",
    marginBottom: "1em"
  },
  noteEditor: {
    marginBottom: "1em"
  },
  footer: {
    color: "rgb(132, 132, 132)"
  },
  footerLink: {
    color: "rgb(132, 132, 132)",
    textDecoration: "underline",
    cursor: "pointer"
  },
  actions: {
    padding: "1em",
    paddingTop: 0
  }
};

class Note extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      isEditing: false,
      hasFocused: false
    };

    this.edit = this.edit.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (!this.state.isEditing && newProps.note) {
      this.setState({
        content: newProps.note.content
      });
    }
  }

  edit() {
    this.setState({
      isEditing: true
    });
  }

  save() {
    let values = {
      person: this.props.person,
      content: this.state.content,
      order: this.props.order
    };

    if (this.props.isNew) {
      NoteActions.create(values);
      if (this.props.onCreate) {
        this.props.onCreate();
      }
    } else {
      NoteActions.edit(this.props.note.id, values);
      this.setState({ isEditing: false });
    }
  }

  delete() {
    if (window.confirm("Are you sure you would like to delete this note?")) {
      NoteActions.delete(this.props.note.id);
    }
  }

  render() {
    let isEditing = this.state.isEditing || this.props.isNew,
      { note, isSaving } = this.props;

    return (
      <Paper zDepth={1}>
        {isEditing ? (
          <div style={STYLES.noteEditor}>
            <BasicHtmlField
              naked={true}
              value={this.state.content}
              onChange={content => this.setState({ content })}
            />
            <div style={STYLES.actions}>
              <RaisedButton
                primary={true}
                disabled={isSaving}
                label={isSaving ? "Saving..." : "Save"}
                style={{ marginRight: 7 }}
                onTouchTap={this.save}
              />
              {this.props.onCancel ? (
                <RaisedButton label="Cancel" onTouchTap={this.props.onCancel} />
              ) : (
                <RaisedButton label="Delete" onTouchTap={this.delete} />
              )}
            </div>
          </div>
        ) : (
          <div style={STYLES.note}>
            <div
              className="tenant-injected-html"
              dangerouslySetInnerHTML={{ __html: this.state.content }}
            />
            <div style={STYLES.footer}>
              {capitalize(moment(note.updated_at).fromNow())} by{" "}
              {note.user_account.name} |{" "}
              <span style={STYLES.footerLink} onTouchTap={this.edit}>
                Edit
              </span>
            </div>
          </div>
        )}
      </Paper>
    );
  }
}

export default Note;



// WEBPACK FOOTER //
// ./src/app/components/partials/notes/note.jsx